var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 64,
    viewBox: "0 0 161 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_3414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.339 44.4155C133.116 44.4155 130.223 45.2316 129.818 45.3481V45.6396V51.2935C129.818 53.5084 130.513 55.4902 130.513 55.4902C131.901 59.6286 136.934 63.7671 137.281 64.0585C137.628 63.7671 142.661 59.6869 144.05 55.4902C144.05 55.4902 144.744 53.5084 144.744 51.2935V45.6396V45.3481C144.455 45.2316 141.562 44.4155 137.339 44.4155ZM137.455 49.6614C136.413 49.6614 135.603 48.7871 135.603 47.7962C135.603 46.747 136.413 45.931 137.455 45.931C138.496 45.931 139.306 46.8053 139.306 47.7962C139.306 48.7871 138.438 49.6614 137.455 49.6614Z",
    fill: "#95E6E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3715 1.28223H45.0078V38.9944H51.3715V1.28223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.9944H6.59504V25.3551H31.7603V19.5846H6.59504V6.99443H37.4298V1.28223H0V38.9944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.455 47.7379C138.091 47.7379 138.554 47.2133 138.612 46.5721V34.9146H136.355V46.6887C136.355 47.2716 136.876 47.7379 137.455 47.7379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.703 0C122.414 0 112.405 7.6357 112.405 19.643C112.405 31.4754 122.645 40.102 136.703 40.102C137.339 40.102 137.976 40.0437 138.612 40.0437V33.9818C137.976 34.0401 137.339 34.0401 136.703 34.0401C127.909 34.0401 118.364 29.5519 118.364 19.7013C118.364 9.79235 127.562 5.88707 136.703 5.88707C150.24 5.88707 155.042 13.0565 155.042 19.7013C155.042 28.0947 148.447 32.5829 140.868 33.7486V39.9271C152.901 38.4699 161 30.6011 161 19.7596C161 7.6357 150.992 0 136.703 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3554 19.5264V25.2969H99.7356V30.1931C96.9587 31.592 90.4794 34.4481 82.6116 34.3898C73.0083 34.2732 65.3719 29.0273 65.3719 19.2933C65.3719 11.4827 71.5042 6.12022 81.4546 6.12022C88.281 6.12022 96.5537 7.81056 98.4628 13.9891H105.347C102.917 3.67213 91.1736 0 81.4546 0C68.0909 0 58.8926 7.98543 58.8926 19.2933C58.8926 32.7577 69.4794 40.3352 82.5537 40.4517C82.6694 40.4517 82.7851 40.4517 82.9008 40.4517C94.9339 40.4517 103.901 34.7978 104.306 34.5647L105.694 33.6903V19.643V19.5264H98.1157H80.3554Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_3414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigoLogo);
export default __webpack_public_path__ + "static/media/figo-logo.1f89960150ab93ff43f06355e07faef0.svg";
export { ForwardRef as ReactComponent };